// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@guestsupply/XDL/types";
import { color, getSystemColor } from "@guestsupply/XDL/Utilities";
import { DataTableCssOverrides } from "@insite/mobius/DataTable/DataTable";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

const _borderStyle = `1px solid ${getSystemColor("common.border")}`;

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        css: css`
            /* as border-collapse: collapse won't work with border-radius */
            border-collapse: separate;
            border-spacing: 0px;
            border: ${_borderStyle};
            /* to make sure we don't have any pixelation in the border-radius */
            overflow: hidden;
            border-radius: 4px;
        `,
        cssOverrides: {
            cell: css`
                padding: 12px;
                height: 46px;
                max-width: 242px;
                vertical-align: initial;
                /* reset border it will init by its own row */
                border-bottom: unset;
                & > ${TypographyStyle} {
                    white-space: break-spaces;
                }
                &:not(:last-child) {
                    border-right: ${_borderStyle};
                }
            `,
            head: css`
                background: ${color("common.ui1")};
            `,
            header: css`
                background: ${color("common.ui1")};
                padding: 8px 12px;
                height: 15px;
                vertical-align: baseline;
                border-bottom: ${_borderStyle};
                &:not(:last-child) {
                    border-right: ${_borderStyle};
                }
                > button {
                    display: inline-flex;
                }
            `,
            row: css`
                background: ${color("common.ui2")};
                /* per cell which not in last row, override the border-bottom */
                &:not(:last-child) > td {
                    border-bottom: ${_borderStyle};
                }
                :hover {
                    background: ${color("common.ui8", 0.2)};
                }
            `,
            evenRow: css`
                background: ${color("common.ui1")};
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 12,
            weight: 500,
            color: "text.main",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        cellTypographyProps: {
            mergeCss: true,
            size: 13,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 20px;
            `,
        },
    },
} as xBaseTheme["dataTable"];
